export const TESTIMONIALS = [
  {
    quote: "We stopped losing jobs to slow quotes. The estimate goes out same-day now, and the office, the crew and the customer all see the same thing.",
    name: "Marcus Hale", role: "Owner", company: "Hale Roofing & Exteriors",
    industry: "roofing", metric: "Quotes out 2x faster",
  },
  {
    quote: "My techs used to call the office six times a day for job details. Now it's all on their phone before they leave the driveway.",
    name: "Dana Whitfield", role: "Operations Manager", company: "TrueNorth HVAC",
    industry: "hvac", metric: "6 fewer office calls per tech per day",
  },
  {
    quote: "Recurring cleans used to live in a spreadsheet I was scared to touch. Now visits generate themselves and clients get proof-of-service photos.",
    name: "Priya Raman", role: "Founder", company: "Clarity Commercial Cleaning",
    industry: "cleaning", metric: "Zero missed visits in 90 days",
  },
  {
    quote: "The readiness flag alone paid for it. Crews stopped showing up to jobs without materials, that was costing us a day a week.",
    name: "Tom Beckett", role: "Project Manager", company: "Beckett Construction Group",
    industry: "construction", metric: "1 full crew-day saved weekly",
  },
  {
    quote: "They configured it around how we actually run calls, not the other way around. First software that didn't make us change our process.",
    name: "Angela Soto", role: "Owner", company: "Soto & Sons Plumbing",
    industry: "plumbing", metric: "Live in 6 days, done-for-you",
  },
  {
    quote: "Customers approve quotes from their phone and confirm appointments themselves. My office manager got her afternoons back.",
    name: "Ray Delgado", role: "Owner", company: "Delgado Electric",
    industry: "electrical", metric: "70% of appointments self-confirmed",
  },
  {
    quote: "Every job closes with photos and a signature before the crew leaves the driveway. Billing same-day instead of same-week.",
    name: "Krystal Novak", role: "Office Manager", company: "Novak Painting Co.",
    industry: "painting", metric: "Invoices out 5 days sooner",
  },
  {
    quote: "Weekly routes just appear on the crew's phones. When someone's out sick, I reassign the whole route in two minutes.",
    name: "Ben Calloway", role: "Owner", company: "Calloway Landscape Co.",
    industry: "landscaping", metric: "Route changes in minutes, not hours",
  },
  {
    quote: "Drying logs, equipment on site, photo documentation, adjusters stopped asking for re-submits. That's real money in restoration.",
    name: "Felix Grant", role: "Mitigation Lead", company: "RapidDry Restoration",
    industry: "restoration", metric: "Zero documentation re-submits",
  },
  {
    quote: "Tenant requests finally have a queue instead of my voicemail. Owners can see job status without calling me, best part of my week.",
    name: "Miriam Osei", role: "Maintenance Director", company: "Keystone Property Care",
    industry: "property-maintenance", metric: "Status calls down to nearly zero",
  },
];

export function testimonialsFor(industry, count = 1) {
  const match = TESTIMONIALS.filter((t) => t.industry === industry);
  const general = TESTIMONIALS.filter((t) => t.industry !== industry);
  return [...match, ...general].slice(0, count);
}
